imageMapEditImageController.$inject = [
  '$scope',
  '$mdDialog',
  '$translate',
  'MediasFactory',
  'AlertingFactory',
  'ImageMapFactory',
  'elementData',
  'elementView',
  'context'
];
export function imageMapEditImageController(
  $scope,
  $mdDialog,
  $translate,
  MediasFactory,
  AlertingFactory,
  ImageMapFactory,
  elementData,
  elementView,
  context
) {
  $scope.save = save;
  $scope.cancel = cancel;
  $scope.removePicture = removePicture;

  let imageTypesAllowed;
  let imageMinWidthAllowed;
  let imageMaxWeightAllowed;
  let imageMaxWeightAllowedInMo;
  let errors;

  init();

  function init() {
    // if elementData is undefined, adding a picture in uploadImage() and setting it manually triggers an error, as it's not an input with ng-model
    $scope.elementData = elementData ? elementData : {};
    $scope.elementView = elementView;
    $scope.site = context.site;
    $scope.companyId = context.companyId;
    $scope.isFormValid = isFormValid;

    $scope.fileNames = {};

    $scope.loading = false;
    $scope.pictureFile = null;
    $scope.mediaUrl = '';
    $scope.weightError;
    $scope.formatError;
    $scope.widthError;
    $scope.errorMessage = '';

    imageTypesAllowed = $scope.elementView.getConfigurationOption('image-allowed-types');
    imageMinWidthAllowed = $scope.elementView.getConfigurationOption('image-min-width');
    imageMaxWeightAllowed = $scope.elementView.getConfigurationOption('image-max-weight');
    imageMaxWeightAllowedInMo = imageMaxWeightAllowed / Math.pow(1024, 2);

    errors = {
      width_error: {
        key: 'parameters/quick_replies/details/graph/line_image_map/edit_image_width_error',
        placeHolders: { width: imageMinWidthAllowed }
      },
      weight_error: {
        key: 'parameters/quick_replies/details/graph/line_image_map/edit_image_weight_error',
        placeHolders: { weight: imageMaxWeightAllowedInMo }
      },
      format_error: { key: 'parameters/quick_replies/details/graph/line_image_map/edit_image_format_error' },
      corrupt_file: { key: 'common/form_errors/corrupted_file' }
    };


    updateErrorMessage();
    updateMediaUrl();

    $scope.$watch('fileNames.picture', function (newFile) {
      if (newFile) {
        removePicture();
        updateErrorMessage();
        if (!imageTypesAllowed.includes(newFile.type)) {
          updateErrorMessage(errors.format_error);
        } else if (newFile.size > imageMaxWeightAllowed) {
          updateErrorMessage(errors.weight_error);
        } else {
          ImageMapFactory.getImageWidthAsync(
            newFile,
            (imageWidth) => {
              if (imageWidth < imageMinWidthAllowed) {
                updateErrorMessage(errors.width_error);
              } else {
                uploadImage(newFile);
              }
            },
            (error) => {
              updateErrorMessage(errors.corrupt_file);
            }
          );
        }
      }
    });
  }

  function save() {
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function removePicture() {
    delete $scope.elementData.url;
    updateMediaUrl();
  }

  function isFormValid() {
    return $scope.editImageMapImageForm.$valid && $scope.mediaUrl !== '';
  }

  function updateMediaUrl() {
    if ($scope.elementData && $scope.elementData.url) {
      $scope.mediaUrl = $scope.elementData.url + '/240';
    } else {
      $scope.mediaUrl = '';
    }
  }

  function uploadImage(file) {
    ImageMapFactory.generateImageVariations($scope.companyId, $scope.site.id, file).then(
      (response) => {
        $scope.elementData = { ...$scope.elementData, ...response.data };
        updateMediaUrl();
      },
      (responseError) => {
        removePicture();
        let error = responseError.data.error;
        if (error.error_message_translation_key) {
          updateErrorMessage({key: error.error_message_translation_key, placeHolders: error.error_message_place_holders });
        }
        // other error than the image itself
        else {
          AlertingFactory.alertHTTPError(responseError)
        }
      }
    );
  }

  function getErrorMessage(translationData) {
    let placeHolders = translationData.placeHolders ? translationData.placeHolders : {};
    return $translate.instant(translationData.key, placeHolders);
  }

  function updateErrorMessage(translationData) {
    if (translationData) {
      $scope.errorMessage = getErrorMessage(translationData);
    } else {
      $scope.errorMessage = '';
    }
  }
}
